module.exports = __webpack_public_path__ + "img/國立臺北藝術大學新媒體藝術學系.62d5712d.png";